// extracted by mini-css-extract-plugin
module.exports = {"item":"desktop_type_item-module__item--jKKwL","selectedItem":"desktop_type_item-module__selectedItem--17TMC"};